import { useContext } from 'react';
import { StateContext } from '../providers/StateProvider';
export const useStateValue = () => useContext(StateContext);
